module.exports = __webpack_public_path__ + "static/media/lucas_giovanetti.58a10866.jpg";